module.exports = __webpack_public_path__ + "static/ecommerce-99e9b79b2cd64e487f01df6474857e2d.png";